<template>
  <div>
    <div
      v-for="journal in journals"
      :key="journal.key"
      class="mb-4"
    >
      <div class="d-flex font-weight-medium text--primary">
        <span>{{ journal.title }}</span>
        <v-spacer></v-spacer>
        <span class="text-no-wrap ms-4">{{ size(journal.sizeBytes) }}</span>
      </div>
      <div
        v-for="section in journal.sections"
        :key="section.name"
        class="d-flex"
      >
        <span>{{ section.period }}</span>
        <v-spacer></v-spacer>
        <span class="text-no-wrap ms-4">{{ size(section.sizeBytes) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { toSizeString } from '@/helpers/exchange-storage'

export default {
  name: 'RemovalList',
  props: {
    journals: {
      type: Array,
      required: true,
    },
  },
  methods: {
    size(bytes) {
      return toSizeString(bytes)
    },
  },
}
</script>
